import Input from "./main.vue";

export default Input;
